import { apiPost, apiDelete, type ApiRequestInit } from './http-client';

export interface RegisterPushTokenPayload {
  device_token: string;
  platform?: string;
  provider?: string;
  app_id?: string;
  device_name?: string;
}

type CapacitorWithConfig = {
  Capacitor?: {
    getConfig?: () => { appId?: string };
  };
};

/** Идентификатор приложения для per-app push-роутинга (user_push_tokens.app_id).
 *  Android (RuStore) ключ клиентских приложений НЕ меняется — com.domcrm.client.
 *  Приоритет: нативный appId из Capacitor config (на Android сборке = com.domcrm.client,
 *  com.domcrm.global / com.domcrm.trainer); fallback — определение бренда по URL embed
 *  (тренерский путь / trainer/, org_slug=sportdom, глобальный embed_global=1).
 *  Для iOS bundle ID выбирается отдельно (resolveIosPushAppId) и используется как
 *  apns-topic при отправке пушей.
 */
export function resolvePushAppId(): string {
  const w = typeof window !== 'undefined' ? window : undefined;
  const cap = (w as CapacitorWithConfig | undefined)?.Capacitor;
  const nativeAppId = cap?.getConfig?.()?.appId;
  if (nativeAppId) return nativeAppId;

  const path = w?.location?.pathname || '';
  const search = w?.location?.search || '';
  if (path.includes('/trainer/')) return 'com.domcrm.trainer';
  if (search.includes('org_slug=sportdom')) return 'com.domcrm.client';
  if (search.includes('embed_global=1')) return 'com.domcrm.global';
  return 'com.domcrm.client';
}

/** iOS Bundle ID установленного приложения по URL embed (клиентские = com.domcrm.clientapp.<slug>,
 *  а НЕ com.domcrm.client как на Android — нейминги платформ МОГУТ различаться). Используется
 *  APNs-топиком при регистрации iOS-токена.
 */
export function resolveIosPushAppId(): string {
  const w = typeof window !== 'undefined' ? window : undefined;
  const path = w?.location?.pathname || '';
  const search = w?.location?.search || '';
  if (path.includes('/trainer/')) return 'com.domcrm.trainer';
  if (search.includes('embed_global=1')) return 'com.domcrm.global';
  if (search.includes('org_slug=liga-tenis')) return 'com.domcrm.clientapp.liga-tennis';
  return 'com.domcrm.clientapp.sportdom';
}

export async function postRegisterPushToken(payload: RegisterPushTokenPayload, init?: ApiRequestInit): Promise<{ status: string; provider: string; user_id: number }> {
  return apiPost<{ status: string; provider: string; user_id: number }>('/api/v1/auth/push-tokens', {
    platform: 'android',
    provider: 'rustore',
    app_id: resolvePushAppId(),
    ...payload
  }, init);
}

export async function postDeactivatePushToken(deviceToken: string, init?: ApiRequestInit): Promise<{ status: string }> {
  return apiDelete<{ status: string }>(`/api/v1/auth/push-tokens?device_token=${encodeURIComponent(deviceToken)}`, init);
}
